
import { v1 as UUID } from "uuid";
import Option from "@/components/examQuesTemplate/js/Option.js"
const judgeOption = [['正确', '错误'],['对','错'],['是','否'],['√','×']]
const letter = ['A','B','C','D','E','F','I','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
const Paper = function () {
    this.title = `<p style="text-align: center;"><span style="font-size: 20px"><strong><span style="color: #10ab97;">考试标题</span></strong></span></p>` // 项目名称（考试）
    this.depict = '感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！' // 项目描述
    this.totalScore = 0 // 试卷总分
    this.pageCount = 0 // 页码类型总数
    this.quesCount = 0 // 试题类型总数
    this.quesAtive = '' // 当前选中项
	this.endPageType = 0 // 完成的状态 0 正常 1 提前
	this.endPageNormalMsg = '<p style="text-align: center;">提交成功，感谢参与</p>' // 正常完成 结束页提示语
	this.endPageAdvanceMsg = '<p style="text-align: center;">不好意思，您不符合本次考试条件，谢谢您的参与</p>' // 提前完成 结束页提示语
    this.questionsList = new Array()
    this.createQuestion = function (ques) {
        // let checkboxArr = [] // 存储多选的答案
        let question = new Question()
        question.qid = UUID()
        let quesinfoArr = [...ques]
        let answerAnalysis = [] // 解析中的答案
        quesinfoArr.forEach((info, index) => {
                if (index == 0) {
                    let title = info
                    let gradeReg = /(\（|\()(\S*)分(\）|\))/g
                    let reg = /(\（|\()([A-Z]+)(\）|\))/g

                    let answerArr = info.match(reg)
                    let answerStr // 题目中的答案
                    if (answerArr) {
                        answerStr = answerArr[0]
                        // console.log(answerStr.slice(1, answerStr.length - 1))
                        answerAnalysis = answerStr.slice(1, answerStr.length - 1).split('')
                        info = info.indexOf(answerStr) > 0 ? info.replace(answerStr, '') : info
                    }
                    let gradeArr = info.match(gradeReg)
                    let grade = '' // 题目中的分数
                    if (gradeArr) {
                        grade = gradeArr[0]
                        question.score = parseInt(grade.slice(1, grade.length - 2)) 
                        info = info.indexOf(grade) > 0 ? info.replace(grade, '') : info
                    }
                    // debugger
                    if (info.indexOf('【单选题】') != -1) {
                        question.quesIndex = this.quesCount
                        this.quesCount++
                        info = info.indexOf('【单选题】') > 0 ? info.replace('【单选题】', '') : info
                        question.questionsName = info
                        question.questionsTypeId = 100
                        question.relation = [{
                            id: ''
                        }] // 试题关联选项的试题id
                        question.associated = [] // 被关联的试题id
                    }else if (info.indexOf('【多选题】') != -1) {
                        question.quesIndex = this.quesCount
                        this.quesCount++
                        info = info.indexOf('【多选题】') > 0 ? info.replace('【多选题】', '') : info
                        question.questionsName = info
                        question.questionsTypeId = 101
                        question.answer = []
                        question.relation = [{
                            id: ''
                        }] // 试题关联选项的试题id
                        question.associated = [] // 被关联的试题id
                    }else if (info.indexOf('【判断题】') != -1) {
                        question.quesIndex = this.quesCount
                        this.quesCount++
                        info = info.indexOf('【判断题】') > 0 ? info.replace('【判断题】', '') : info
                        let judgeReg = /(\（|\()((正确|错误)|(对|错)|(是|否)|(√|×))(\）|\))/g
                        let judgeArr = info.match(judgeReg)
                        let judgeStr // 题目中的答案
                        if (judgeArr) {
                            judgeStr = judgeArr[0]
                            question.answer = judgeStr.slice(1, judgeStr.length - 1)
                            info = info.indexOf(judgeStr) > 0 ? info.replace(judgeStr, '') : info
                        }
                        question.questionsName = info
                        question.questionsTypeId = 102
                    }else if (info.indexOf('【填空题】') != -1) {
                        question.quesIndex = this.quesCount
                        this.quesCount++
                        info = info.indexOf('【填空题】') > 0 ? info.replace('【填空题】', '') : info
                        question.questionsName = info
                        question.questionsTypeId = 204
                    }else if (info.indexOf('【简答题】') != -1) {
                        question.quesIndex = this.quesCount
                        this.quesCount++
                        info = info.indexOf('【简答题】') > 0 ? info.replace('【简答题】', '') : info
                        question.questionsName = info
                        question.questionsTypeId = 206
                    }else if (info.indexOf('【段落说明】') != -1) {
                        question.questionsName = info.replace('【段落说明】', '')
                        question.questionsTypeId = 401
                    } else if (info.indexOf('结束语-正常结束') != -1) {
                        this.endPageType = 0
                        this.endPageNormalMsg = info
                    } else {
                        question.quesIndex = this.quesCount
                        this.quesCount++
                        question.questionsName = info
                        question.questionsTypeId = 100
                    }
                    quesinfoArr.splice(index, 1)
                }
        })
        
        quesinfoArr.forEach((info, index) =>{
            if(info.indexOf('答案解析：') != -1 || info.indexOf('答案解析:') != -1) {
                question.analysis = info.slice(5)
            } else if (info.indexOf('正确答案：') != -1 || info.indexOf('正确答案:') != -1) {
                if(question.questionsTypeId == 100 || question.questionsTypeId == 101) {
                    answerAnalysis = (answerAnalysis + info.slice(5)).split('')
                    answerAnalysis = answerAnalysis.filter(item => {return item != ' '})
                } else {
                    question.answer = question.answer + info.slice(5)
                }
            } else {
                if(question.questionsTypeId == 100 ) {
                    let option = new Option()
                    if(info.indexOf('（正确答案）') != -1) {
                        option.labelName = info.slice(0, info.length - 6)
                        question.answer = option.oid
                    } else {
                        option.labelName = info
                    }
                    if(option.labelName.indexOf('【文本填写】') !== -1){
                        option.labelName = option.labelName.replace('【文本填写】', '')
                        option.haveInput = true
                        option.inputValue = ''
                    }
                    question.optionList.push(option)
                } else if(question.questionsTypeId == 101 ) {
                    let option = new Option()
                    if(info.indexOf('（正确答案）') != -1) {
                        option.labelName = info.slice(0, info.length - 6)
                        question.answer.push(option.oid)
                    } else {
                        option.labelName = info
                    }
                    if(option.labelName.indexOf('【文本填写】') !== -1){
                        option.labelName = option.labelName.replace('【文本填写】', '')
                        option.haveInput = true
                        option.inputValue = ''
                    }
                    question.optionList.push(option)
                }
            }
        })
        // console.log(answerAnalysis)
        // console.log('----------')
        // console.log('答案'+question.answer)
        // 选项中的ABC必须大写 
        if(question.questionsTypeId == 100) {
            if(answerAnalysis.length > 1) {
                question.questionsTypeId = 101
                question.answer = []
                answerAnalysis.forEach((info, index) => {
                    letter.forEach((el, elIndex) => {
                        if (info.indexOf(el) != -1)  {
                            question.answer.push(question.optionList[elIndex]?.oid)
                        }
                    })
                })
                // question.answer = question.answer.join(',')
            } else if(answerAnalysis.length == 1) {
                if (question.answer) {
                    let arr = [question.answer]
                    // console.log(arr)
                    question.questionsTypeId = 101
                    answerAnalysis.forEach((info, index) => {
                        letter.forEach((el, elIndex) => {
                            if (info.indexOf(el) != -1)  {
                                arr.push(question.optionList[elIndex]?.oid)
                            }
                        })
                    })
                    question.answer = arr
                } else {
                    letter.forEach((info, index) => {
                        if ( answerAnalysis[0].indexOf(info) != -1) {
                            question.answer = question.optionList[index]?.oid
                        }
                    })
                }
            }
            // console.log(question.answer)
        }else if(question.questionsTypeId == 101) {
            let arr = [...question.answer]
            answerAnalysis.forEach((info, index) => {
                letter.forEach((el, elIndex) => {
                    if (info.indexOf(el) != -1)  {
                        arr.push(question.optionList[elIndex]?.oid)
                    }
                })
            })
            question.answer = arr
        } else if(question.questionsTypeId == 102){
            // console.log(question.answer)
            // debugger
            judgeOption.forEach((info, index) => {
                info.forEach((el, elIndex) => {
                    if(question.answer.indexOf(el) != -1) {
                        for(let i = 0; i < 2; i++){
                            let option = new Option()
                            question.optionList.push(option)
                        }
                        question.answer = question.optionList[elIndex].oid
                        question.optionList[0].labelName = info[0]
                        question.optionList[1].labelName = info[1]
                    }
                })
            })
        }
        this.totalScore = this.totalScore + parseInt(question.score)
        this.questionsList.push(question)
    }
}

const Question = function () {
    this.qid = 0 // 试题id
    this.questionsTypeId = '' // 试题类型
    this.questionsName = '' // 试题名称
    this.mustanswer = true; //是否必填
    this.showcolnum = 1; //显示列数
    this.minNum = 0 // 最小限制字数
    this.maxNum = 0 // 最大限制字数
    this.decimalPlaces = 0 // 保留小数位数
    this.isHideTitle = false // 是否隐藏该题
    this.isHideScore = false // 答案与分值
    this.scoringType = 1 // 计分方式
    this.analysis = '' // 答案解析
    this.score = 0 // 试题总分
    this.answer = '' // 答案,
    this.noAnswer = '' // 用于前端绑定选项
    this.optionList = []
    this.isedit = false; //是否编辑问题
    if (this.questionsTypeId == 206) {
        this.inputHeight = '大' // 输入框高度(填空、简答)
    } else {
        this.inputHeight = '小'
    }
}

export {
    Paper,
    Question,
} 